import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-why-fi',
  templateUrl: './work-why-fi.component.html',
  styleUrls: ['./work-why-fi.component.scss']
})

export class WorkWhyFiComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }
}




// WEBPACK FOOTER //
// ./src/app/work-why-fi/work-why-fi.component.ts